<template>
  <div id="app">

    <Nav v-if="tokenAuth"/>
    <div  :class="tokenAuth?'makeStyles-content-10':'height-100'" >
    <router-view></router-view>
    <loader ></loader>
    <alert-message ></alert-message>
    </div>
    
  </div>
</template>

<script>

import Nav from './components/Nav'

import {mapState} from 'vuex'
import Loader from './components/Loader.vue'
import AlertMessage from './components/AlertMessage.vue'
export default {
  name: 'App',
  components: {
  Nav,
    Loader,
    AlertMessage
  },
  computed: {
  ...mapState('module',['tokenAuth']),
  ...mapState({
      showAlert: (state) => state.showAlert,
      isLoading:state=>state.isLoading
    }),
  }
}
</script>

<style >
@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
html, body {
    height: 100%;
}
#app{height: 100%;display: flex;}
html, body {
  font-family: 'Montserrat', sans-serif;
}

#app {
  font-family: 'Montserrat', sans-serif;
}
.makeStyles-content-10 {
    flex-grow: 1;
    display: block;
    margin-top: 60px;
   background:#F8F8F8
}
.height-100{height: 100%;width:100%;}
</style>
